import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';

import theme from './theme';
import MainLayout from './components/layout/MainLayout';
import LoadingScreen from './components/common/LoadingScreen';
import CookieConsent from './components/common/CookieConsent';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';

// Title updater component
const TitleUpdater = () => {
  const location = useLocation();
  
  useEffect(() => {
    const titles = {
      '/': 'HypeNode Nusantara - Digital Agency',
      '/about': 'About - HypeNode Nusantara',
      '/services': 'Services - HypeNode Nusantara',
      '/portfolio': 'Portfolio - HypeNode Nusantara',
      '/contact': 'Contact - HypeNode Nusantara',
    };
    document.title = titles[location.pathname] || 'HypeNode Nusantara';
  }, [location]);

  return null;
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AnimatePresence mode="wait">
        {loading && <LoadingScreen />}
      </AnimatePresence>
      <Router>
        <TitleUpdater />
        <AnimatePresence mode="wait">
          <MainLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </MainLayout>
        </AnimatePresence>
      </Router>
      <CookieConsent />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#0f2040',
            color: '#e8edf5',
            border: '1px solid rgba(79,195,247,0.1)',
            borderRadius: '12px',
          },
        }}
      />
    </ThemeProvider>
  );
}

export default App;
